import { useEffect, useState, useCallback } from "react";
import { auth, rtdb } from "../config/firebase";
import { signOut } from "firebase/auth";
import { useAuthState } from "react-firebase-hooks/auth";
import { onDisconnect, set, update, serverTimestamp } from "firebase/database";
import { ref } from "firebase/database";

const INACTIVITY_TIMEOUT = 30 * 60 * 1000; // 30 minutes
// const INACTIVITY_TIMEOUT = 1 * 60 * 1000; // 30 minutes



const offlineStatus = { isOnline: false, lastSeen: serverTimestamp() }; // serverTimestamp must be imported from firestore/database

export const useInactivityLogout = () => {
  const [lastActivity, setLastActivity] = useState(Date.now());

  const [user] = useAuthState(auth);

  const handleLogout = useCallback(async () => {
    if (user?.uid) {
      const userStatusRef = ref(rtdb, `status/${user?.uid}`);
      try {
        await onDisconnect(userStatusRef).cancel();
     

        await update(userStatusRef, offlineStatus);
 
      } catch (dbError) {
        console.error(
          "⚠️ Error updating RTDB status on logout, continuing sign out:",
          dbError
        );
      }
    }

    signOut(auth)
      .then(() => {
       
      })
      .catch((error) => {
        console.error("Error signing out:", error);
      });
  }, [user]);

  const handleActivity = useCallback(() => {
    setLastActivity(Date.now());
  }, []);

  useEffect(() => {
    const activityEvents = ["mousemove", "keydown", "click", "scroll"];

    activityEvents.forEach((event) => {
      window.addEventListener(event, handleActivity);
    });

    const interval = setInterval(() => {
      if (Date.now() - lastActivity > INACTIVITY_TIMEOUT) {
        if (user?.uid) {
          handleLogout();
        }
      }
    }, 1000); // Check every second

    return () => {
      activityEvents.forEach((event) => {
        window.removeEventListener(event, handleActivity);
      });
      clearInterval(interval);
    };
  }, [lastActivity, handleLogout, handleActivity]);

  return null;
};
